import React from 'react';
import { Typography } from '@material-ui/core';
import Button from 'components/UI/V2/Button/Button';
import { ConfirmDialog } from 'components/UI';
import { Enrollment } from '@spike/membership-model';
import { SelectField } from 'components/UI';

interface Props {
    open: boolean;
    enrollment: Enrollment | null;
    onCancel: () => void;
    onConfirm: (reason: string) => void;
    confirmLabel?: string;
    cancelLabel?: string;
    questionClassName?: string;
    subquestionClassName?: string;
}

const CancelEnrollmentDialog: React.FC<Props> = ({
    open,
    enrollment,
    onCancel,
    onConfirm,
    confirmLabel = 'Yes, Cancel',
    cancelLabel = 'Cancel',
    questionClassName,
    subquestionClassName
}) => {
    const [selectedReason, setSelectedReason] = React.useState<string>('No reason provided');

    const reasons = [
        { id: 1, name: 'No reason provided' },
        { id: 2, name: 'Cost Considerations' },
        { id: 3, name: 'Quality of Service' },
        { id: 4, name: 'Scheduling Availability' },
        { id: 5, name: 'Pet Behavior Concerns' },
        { id: 6, name: 'Alternative Options' }
    ];

    const selectReasonHandler = (selectedField: { id: string | number; name: string }) => {
        setSelectedReason(selectedField.name);
    };

    return (
        <ConfirmDialog
            open={open}
            title={'Cancel Membership'}
            question={
                <Typography className={questionClassName}>
                    Canceling{' '}
                    <b style={{ fontWeight: '600' }}>
                        {enrollment?.clientName}’s {enrollment?.membership.name}
                    </b>{' '}
                    for <b style={{ fontWeight: '600' }}>{enrollment?.pets.map(pet => pet.name).join(', ')}</b>{' '}
                    permanently stops its use.
                </Typography>
            }
            subquestion={
                <SelectField
                    className={subquestionClassName}
                    label="Cancellation reason"
                    placeholder="No reason provided"
                    options={reasons}
                    onSelect={selectReasonHandler}
                />
            }
            onCancel={onCancel}
            actions={
                <>
                    <Button
                        fullWidth
                        size="large"
                        variant="black"
                        label={cancelLabel}
                        style={{ minWidth: 'unset' }}
                        onClick={e => {
                            e.stopPropagation();
                            onCancel();
                        }}
                    />
                    <Button
                        fullWidth
                        size="large"
                        variant={'danger'}
                        label={confirmLabel}
                        style={{ margin: 0, minWidth: 'unset' }}
                        onClick={e => {
                            e.stopPropagation();
                            onConfirm(selectedReason);
                        }}
                    />
                </>
            }
        />
    );
};

export default CancelEnrollmentDialog;
